import Vue from 'vue'

export default Vue.extend({
  name: 'SimpleDialog',
  props: {
    show: Boolean,
    title: {
      type: String,
      default: 'Are you sure about this?'
    },
    description: {
      type: String,
      default: ''
    },
    cancel: {
      type: String,
      default: 'No'
    },
    confirm: {
      type: String,
      default: 'Yes'
    },
    cancelColor: {
      type: String,
      default: 'green'
    },
    confirmColor: {
      type: String,
      default: 'green'
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },

    submit () {
      this.$emit('submit')
      this.close()
    }
  }
})
